import { calculatePercentage } from "@utilities/calculate-percentage";
export class LearningMethods {
    total;
    methods;
    constructor(
    /* Total amount of bookings from all the booking types */
    total, methods) {
        this.total = total;
        this.methods = methods;
    }
    static fromJson(json) {
        const { learning_types: dto } = json;
        const total = dto.reduce((total, dto) => total + dto.value, 0);
        const methods = dto.map((dto) => new LearningMethod(dto.label, dto.value));
        const percentages = methods.map((method) => {
            return new LearningMethod(method.label, method.toPercentage(total));
        });
        return new LearningMethods(total, percentages);
    }
}
export class LearningMethod {
    label;
    value;
    constructor(
    /* Booking method */
    label, 
    /* Amount of bookings */
    value) {
        this.label = label;
        this.value = value;
    }
    toPercentage(total) {
        return calculatePercentage(total, this.value);
    }
}
